import { hideBetchuShippingDates } from './betchu'
import { afterOldScripts } from '../shared/after-old-scripts'

// wuSiteResource2 側の旧実装（同じ<script>共通部に async で残っている）が
// 同じ option を無条件で削るため、旧の実行が終わってから動く必要がある
// （betchu.ts 側の「既に削られていたら何もしない」ガードは旧→新の順にしか効かず、
// 新が先に走ってしまう逆順は防げない）。順序の保証は shared/after-old-scripts.ts。
export default function initCartBetchuShipping(): void {
  afterOldScripts(() => {
    const select = document.querySelector<HTMLSelectElement>('.shipping_date_selection')
    if (select) hideBetchuShippingDates(select)
  })
}
